import React, { useEffect, useState } from 'react'
import { getDriverAccepted } from '../../../Api/TaxiServices'
import Style from './TaxiRequests.module.css'
import TaxiCurrentTravelDetail from '../../../Component/TaxiCurrentTravelDetail/TaxiCurrentTravelDetail'
const TaxiRequests = () => {
  const[TravelsState,setTravelsState]=useState()
  const MINUTE_MS=6000

  useEffect(()=>{
    getCurrentTravelData()
    const interval = setInterval(() => {
      getCurrentTravelData()
    }, MINUTE_MS);
    return () => clearInterval(interval)
  },[])
  
  const getCurrentTravelData=()=>{
    getDriverAccepted((succ,res)=>{
      if(succ){
        if(res.staus===-1){
          console.log(res.message)
        }else{
          setTravelsState(res.request)
        }
      }else{
        console.log(res)
      }
    })
  }
  return (
    <div className={Style.componentHolder}>
    {
      TravelsState===undefined?<p>درحال دریافت اطلاعات....</p>:TravelsState.length===0?<p>سفری یافت نشد!</p>:<TaxiCurrentTravelDetail data={TravelsState[0]}/>
    }
  </div>
  )
}

export default TaxiRequests